let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lGNGL")).then(() => parcelRequire('lewnL'));